import { render, staticRenderFns } from "./addSeal.vue?vue&type=template&id=0b773316&scoped=true&"
import script from "./addSeal.vue?vue&type=script&lang=js&"
export * from "./addSeal.vue?vue&type=script&lang=js&"
import style0 from "./addSeal.vue?vue&type=style&index=0&id=0b773316&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b773316",
  null
  
)

export default component.exports